import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private translateService: TranslateService) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let lang = this.translateService.getDefaultLang();
    if (lang == 'en') {
      lang = 'en-CA';
    } else if (lang == 'fr') {
      lang = 'fr-CA';
    }

    let token = localStorage.getItem('token');
    if (!token) {
      token = this.authService.getUser()
        ? this.authService.getUser()?.token ?? null
        : null;
    }


    if (token && this.tokenExpired(token)) {
      token = null;
    }

    if (!request.url.includes('assets')) {
      if (token) {
        const headers = request.headers.set('Authorization', 'bearer ' + token);
        request = request.clone({ headers });
      }

      const timestamp = Date.now();
      let urlWithTimestamp = '';
      if (request.url.includes('?')) {
        //add timestamp on url for avoiding caching
        urlWithTimestamp = `${request.url}&${timestamp}&lang=${lang}`;
      } else {
        urlWithTimestamp = `${request.url}?${timestamp}&lang=${lang}`;
      }

      request = request.clone({
        url: urlWithTimestamp,
      });
    }

    return next.handle(request);
  }

  private tokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }


}
